import {Link} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {CommentDeletedEvent$key} from './__generated__/CommentDeletedEvent.graphql'
import {TimelineRow} from './row/TimelineRow'

type CommentDeletedEventProps = {
  queryRef: CommentDeletedEvent$key
  issueUrl: string
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function CommentDeletedEvent({
  queryRef,
  issueUrl,
  highlightedEventId,
  refAttribute,
}: CommentDeletedEventProps): JSX.Element {
  const {actor, createdAt, deletedCommentAuthor, databaseId} = useFragment(
    graphql`
      fragment CommentDeletedEvent on CommentDeletedEvent {
        databaseId
        createdAt
        actor {
          ...EventActor
          ...EventActorAvatarItemBadge
        }
        deletedCommentAuthor {
          login
        }
      }
    `,
    queryRef,
  )

  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      actorAvatar={actor}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
    >
      <>
        {`${LABELS.timeline.deletedACommentFrom} `}
        <Link href={`/${deletedCommentAuthor?.login}`} sx={{color: 'fg.default'}} muted>
          {deletedCommentAuthor?.login}
        </Link>{' '}
      </>
    </TimelineRow>
  )
}

try{ CommentDeletedEvent.displayName ||= 'CommentDeletedEvent' } catch {}